import { render, staticRenderFns } from "./ConfirmAllocationDialog.vue?vue&type=template&id=a35b9bc4&scoped=true"
import script from "./ConfirmAllocationDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmAllocationDialog.vue?vue&type=script&lang=js"
import style0 from "./ConfirmAllocationDialog.vue?vue&type=style&index=0&id=a35b9bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35b9bc4",
  null
  
)

export default component.exports